import styled from "styled-components";

export const SeeDetails = styled.a`
  font: 600 12px/1;
  color: #fe2f67;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;


export const DonorCard = styled.div`
  width: 100%;
  min-height: 55px;
  background: #f7f4f4;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DonorCardTitle = styled.p`
  font: 600 14px/1;
`;

export const DonorCardTag = styled.p`
  font: 400 12px/1;
  color: #8f8f8f;
`;

export const DonorCardNumber = styled.p`
  font: 600 12px/1;
  color: #fe2f67;
`;

export const PageContainer = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 1rem;
`;

export const EditButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: #fe2f67;
  font-weight: 600;
  cursor: pointer;
`;

export const TwoColumnLayout = styled.div`
  display: flex;
  gap: 2rem;
  background: #f6f4f4;
`;

export const LeftColumn = styled.div`
  flex: 6 0 0;
  padding: 1.5rem;
  margin: 1.5rem;
  background: white;
  border-radius: 8px;
  @media (max-width: 768px) {
    flex: 1 0 100%;
    max-width: 100%;
  }
`;

export const RightColumn = styled.div`
  flex: 4 0 0;
  @media (max-width: 768px) {
    flex: 1 0 100%;
    max-width: 100%;
  }
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

















export const CoverTextOverlay = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  color: #fff;
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
`;











export const StatsHeader = styled.h3`
  font-size: 1.25rem;
  margin: 0 0 0.5rem;
`;





export const DonateButton = styled.button`
  display: inline-block;
  width: 100%;
  padding: 0.75rem 1rem;
  margin: 1rem 0;
  font-size: 1rem;
  background: #4caf50;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
`;


export const TopDonorsTitle = styled.h4`
  font-size: 1.1rem;
  margin: 1rem 0 0.5rem;
`;

export const TopDonorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TopDonorItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopDonorName = styled.span`
  font-weight: 600;
`;

export const DonorMessage = styled.span`
  font-style: italic;
  font-size: 0.9rem;
  color: #333;
`;

export const AllDonorsButton = styled.button`
  background: none;
  border: none;
  color: #0066cc;
  padding: 0;
  margin-top: 0.25rem;
  text-align: left;
  cursor: pointer;
  font: inherit;
  text-decoration: underline;
`;



export const DonorListItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.25rem 0;
  border-bottom: 1px solid #eee;
  font-size: 0.95rem;
`;


export const EventDetails = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: #555;
`;

export const PostCaption = styled.p`
  position: absolute;
  inset: 0;
  margin: 0;
  padding: 1rem;
  color: #333;
  font-size: 0.875rem;
  line-height: 1.4;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f5f5f5;
`;


export const SeeAllLink = styled.button`
  background: none;
  border: none;
  color: #fe2f67;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  text-transform: lowercase;
  &:hover {
    text-decoration: underline;
  }
`;


